import React from "react";
import Button from "../../../../CommonElements/Button";
import Container from "../../../../CommonElements/Container";
import OutgoingArrow from "../../../../CommonElements/OutgoingArrow";
import { useLanguage } from "../../../../context/LanguageContext";
import { useSignupModal } from "../../../../context/SignupModalContext";
import useReveal from "../../../../hooks/useReveal";
import bear from "../../../../assets/images/bear.svg";
import bull from "../../../../assets/images/bull.svg";

const BottomCta = () => {
  const { openSignup } = useSignupModal();
  const { t } = useLanguage();
  const [revealRef, inView] = useReveal();

  return (
    <section className={`section bottom-cta${inView ? " is-in" : ""}`} id="participate" ref={revealRef}>
      <Container className="bottom-cta__content">
        <h2 className="bottom-cta__title">{t("bottomCta.title")}</h2>
        <p className="bottom-cta__text">{t("bottomCta.text")}</p>
        <Button
          variant="solid"
          size="lg"
          icon={<OutgoingArrow size={18} />}
          onClick={openSignup}
        >
          {t("hero.participateNow")}
        </Button>
      </Container>

      <div className="bottom-cta__animals" aria-hidden="true">
        <span className="bottom-cta__crop">
          <img className="bottom-cta__bear" src={bear} alt="" width={332} height={293} />
        </span>
        <span className="bottom-cta__crop">
          <img className="bottom-cta__bull" src={bull} alt="" width={389} height={293} />
        </span>
      </div>
    </section>
  );
};

export default BottomCta;
